import * as React from 'react';
import { Dispatch } from 'redux';
import { EventsStatsMap } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import { NormalizedEventStatistics, normalizeEventStatistics } from '../normalizers/eventStatisticsNormalizers';

export class GetAllEventsStatisticsRequest extends BaseApiGetRequest<
  EventsStatsMap,
  EntityNormalizers.NormalizedEntityArray<NormalizedEventStatistics>
> {
  constructor(component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/event-statistics`;
    this.normalizeMethod = normalizeEventStatistics;
  }
}
